import React from 'react';
import Lottie from 'lottie-react';
import { LoadingJson,Loadss,Loadssmp4 } from 'assets';
import styles from './style.module.scss';
import classNames from 'classnames';



function LottieAnimation() {
  return (
    <div className={classNames(styles.oaderwrapper)}>
      <div className={classNames(styles.spinner)}></div>
    </div>
  );
}

export default LottieAnimation;